"use client";

import clsx from "clsx";
import {
  ChangeEvent,
  FC,
  PropsWithChildren,
  useCallback,
} from "react";

import { PropsWithTestId } from "../types";

interface Props extends PropsWithChildren, PropsWithTestId {
  value?: string;
  onChange(s: string): void;
  placeholder?: string;
}

export const Select: FC<Props> = ({
  value,
  children,
  onChange,
  placeholder = "",
  "data-testid": dataTestId,
}) => (
  <select
    value={value ?? placeholder}
    onChange={useCallback((e: ChangeEvent<HTMLSelectElement>) => onChange(e.target.value), [ onChange ])}
    className={clsx(
      "rounded-md border-gray-400 text-right",
      value === undefined && "text-gray-400",
    ) }
    data-testid={ dataTestId }
  >
    <option disabled hidden>{ placeholder }</option>
    { children }
  </select>
);
